module.exports = __webpack_public_path__ + "static/img/case-page-bg-06.b8ac952.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/case-page-bg-06.png
// module id = 5M+S
// module chunks = 1